module.exports = __webpack_public_path__ + "static/img/deportes_09.1386f54a.jpeg";